export default __webpack_public_path__ + "static/vi-testimonial-bg-mobile-dark-aab831a444f1b519ca7912409eab1327.png";